const info = require('./info.json');
const inquiry = require('./inquiry.json');
const transaction = require('./transaction.json');

function delay(value, time = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve.bind(null, value), time);
  });
}

export default {
  getInfo: () => delay(info),
  inquiry: () => delay(inquiry),
  createTransaction: () => delay(transaction),
  abortRequest: () => delay({}),
};
